import React from 'react';
import { Feedback } from '@questlabs/react-sdk';
import SafeIcon from '../common/SafeIcon';

const CandidateFeedback = () => {
  const styleConfig = {
    Form: {
      backgroundColor: '#FFFFFF',
      borderRadius: '4px',
      padding: '24px',
      boxShadow: '0 4px 18px 0 rgba(75,70,92,0.1)',
      border: '1px solid #f1f5f9'
    },
    Topbar: {
      borderBottom: '1px solid #f1f5f9',
      marginBottom: '20px',
      paddingBottom: '16px'
    },
    Heading: {
      color: '#11469A',
      fontSize: '20px',
      fontWeight: '700',
      fontFamily: '"Public Sans", sans-serif'
    },
    Description: {
      color: '#6b7280',
      fontSize: '14px',
      marginBottom: '24px'
    },
    Label: {
      color: '#4b5563',
      fontSize: '13px',
      fontWeight: '600',
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
      marginBottom: '8px'
    },
    Input: {
      backgroundColor: '#FFFFFF',
      border: '1px solid #ced4da',
      borderRadius: '4px',
      height: '44px',
      fontSize: '14px',
      color: '#212529'
    },
    TextArea: {
      backgroundColor: '#FFFFFF',
      border: '1px solid #ced4da',
      borderRadius: '4px',
      fontSize: '14px',
      color: '#212529',
      minHeight: '120px'
    },
    PrimaryButton: {
      backgroundColor: '#00AEEF',
      color: '#FFFFFF',
      borderRadius: '4px',
      fontWeight: '700',
      fontSize: '13px',
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
      height: '48px',
      padding: '0 32px',
      transition: 'all 0.3s ease'
    },
    SingleChoice: {
      style: {
        backgroundColor: '#f8fafc',
        border: '1px solid #e2e8f0',
        borderRadius: '4px',
        padding: '12px 16px',
        color: '#4b5563',
        fontSize: '14px',
        transition: 'all 0.2s ease'
      },
      selectedStyle: {
        backgroundColor: '#00AEEF',
        border: '1px solid #00AEEF',
        color: '#FFFFFF'
      },
      hoverBackground: '#f1f5f9'
    },
    MultiChoice: {
      style: {
        backgroundColor: '#f8fafc',
        border: '1px solid #e2e8f0',
        borderRadius: '4px',
        padding: '12px 16px',
        color: '#4b5563',
        fontSize: '14px'
      },
      selectedStyle: {
        backgroundColor: '#00AEEF',
        border: '1px solid #00AEEF',
        color: '#FFFFFF'
      },
      isLabel: true
    },
    listHover: {
      background: '#f8fafc',
      iconBackground: '#00AEEF',
      iconColor: '#FFFFFF',
      Heading: '#11469A',
      Description: '#6b7280',
      Icon: { color: '#6b7280' },
      defaultIconBackground: '#f1f5f9'
    }
  };

  return (
    <div className="space-y-6 max-w-4xl mx-auto">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Candidate Feedback</h1>
          <p className="text-gray-500">Collect and manage feedback on the application process.</p>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-8">
        <div className="bg-white rounded-xl overflow-hidden">
          <Feedback 
            styleConfig={styleConfig}
            questId="your-quest-id-here" // Provided by user in production
            userId="admin-hr"
          />
        </div>

        <div className="card p-6 bg-[#11469A] text-white overflow-hidden relative">
          <div className="absolute top-0 right-0 p-8 opacity-10">
            <SafeIcon name="MessageSquare" size={120} />
          </div>
          <div className="relative z-10">
            <h3 className="text-xl font-bold mb-2">Why collect feedback?</h3>
            <p className="text-white/80 text-sm max-w-xl leading-relaxed">
              Understanding the candidate experience helps us refine our recruitment process, 
              improve our employer brand, and ensure we're attracting the best talent in Ghana.
            </p>
            <div className="mt-6 flex gap-4">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-[#00AEEF]"></div>
                <span className="text-xs font-bold uppercase tracking-wider">Process Improvement</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-[#00AEEF]"></div>
                <span className="text-xs font-bold uppercase tracking-wider">Talent Retention</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CandidateFeedback;